import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CandidateStatusType } from './candidate-status-type.interface';
import { CandidateStatusTypeService } from './candidate-status-type.service';

const service = new CandidateStatusTypeService();

export interface CandidateStatusTypeState {
   candidateStatusTypes: Array<CandidateStatusType>;
}

const CandidateStatusTypeStore: Module<CandidateStatusTypeState, StoreState> = {
   namespaced: true,
   state: {
      candidateStatusTypes: [],
   },
   getters: {},
   mutations: {
      SET_CANDIDATE_STATUS_TYPES(state, candidateStatusTypes) {
         state.candidateStatusTypes = candidateStatusTypes;
      },
   },
   actions: {
      async getCandidateStatusTypes(context) {
         const response = await service.getCandidateStatusTypes();
         context.commit('SET_CANDIDATE_STATUS_TYPES', response.data);
         return response.data;
      },
   },
};

export default CandidateStatusTypeStore;
